import { INIT_LIVE_INFO, SET_BANNER_LIST, GET_CUSTOM_LIVEFUNCIONS, INIT_LIVE_DATA } from '../../actions/modules/ModulesActionsLive';

/**
 * 初始化STATE
 */
export const initialState: any = {};

/**
 * channel
 */
function channel(state: any = initialState, action: any): any {
	const { type, item } = action;

	switch (type) {
		case INIT_LIVE_DATA:
			return {
				...state,
				...action.data,
			};
		case INIT_LIVE_INFO:
			return {
				...state,
				liveInfo: action.data,
			};
		case SET_BANNER_LIST:
			return {
				...state,
				mgrBannerList: action.data,
			};
		case GET_CUSTOM_LIVEFUNCIONS:
			let newState: any = { ...state };

			if (state.liveInfo.liveFunction && state.liveInfo.liveFunction.functions) {
				if (action.payload) {
					newState.liveInfo.liveFunction.functions.forEach((item: any): void => {
						const target: any = action.payload.find((cus: any): boolean => cus.id === item.code);
						if (target) {
							item.icon = target.icon;
						}
					});
				}
			}

			return newState;
		default: {
			return state;
		}
	}
}

export default channel;
